module.exports = __webpack_public_path__ + "img/19.271f49d5.svg";